import React from "react";
import { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { APILA } from "../../../../../config/apila";
import { APIMS } from "../../../../../config/apims";
import "bulma/css/bulma.css";
import "../../../../../index.css";
import swal from "sweetalert";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import ModalLeger from './modal/legerSuper';
import { faBookOpenReader, faMagnifyingGlass, faFilter, faEye } from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import ModalRapor from './modal/rapor';

/* ===========================
   🔥 SKELETON SHIMMER STYLE
=========================== */
const shimmerStyle = `
  @keyframes shimmer {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }

  .shimmer {
    animation: shimmer 1.2s linear infinite forwards;
    background: linear-gradient(
      to right,
      #ddeaff 8%,
      #f4f8ff 18%,
      #ddeaff 33%
    );
    background-size: 800px 104px;
  }
`;

export default function Leger() {
  document.title = "Rapor";

  const [page] = useState(1);
  const [limit] = useState(1000);
  const [ascending] = useState(1);
  const [descending] = useState(0);
  const [keyword] = useState("");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [loadingSchool, setLoadingSchool] = useState(false);

  const firstLoadDone = useRef(false);
  const initSchoolDone = useRef(false);
  const initLevelDone = useRef(false);
  const initKelasDone = useRef(false);

  const storageBranchGroping = localStorage.getItem("ysb_branch_id");
  const storageLevel = localStorage.getItem("level");

  // Data master
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
  const [getDataBranch, setGetDataBranch] = useState([]);
  const [getDataSchool, setGetDataSchool] = useState([]);
  const [getDataTeacher, setGetDataTeacher] = useState([]);

  // Tingkatan & Kelas
  const [getDataLevel, setGetDataLevel] = useState([]);
  const [getDataKelas, setGetDataKelas] = useState([]);
  const [loadingLevel, setLoadingLevel] = useState(false);
  const [loadingKelas, setLoadingKelas] = useState(false);

  const [searchKeyword, setSearchKeyword] = useState("");

  // Table data
  const [getData, setGetData] = useState([]);
  const [getDataKop, setGetDataKop] = useState([]);

  // UI state
  const [hasSearched, setHasSearched] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFilterDirty, setIsFilterDirty] = useState(false);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const [namaTA, setNamaTA] = useState("");
  const [namaSmstr, setNamaSmstr] = useState("");

  // Filter form
  const [form2, setForm2] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id:"",
    ysb_kelas_id:"",
    ysb_teacher_id: "",
  });

  // Permission
  const location = useLocation();
  const [permission, setPermission] = useState({
    create: 0,
    read: 0,
    update: 0,
    delete: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const level = localStorage.getItem("level");
    const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
    if (level === "developer" || level === "superadmin") {
    setPermission({ create: 1, read: 1, update: 1, delete: 1 });
    return;
    }
    const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
    if (!foundPermission) navigate("/dashboard");
    else {
    setPermission({
    create: foundPermission.create,
    read: foundPermission.read,
    update: foundPermission.update,
    delete: foundPermission.delete,
    });
    }
  }, [location.pathname, navigate]);

  /* API HEADERS */
  const fetchParams = useMemo(
    () => ({
    headers: {
    Authorization: `${token}`,
    "Content-Type": "application/json",
    },
    }),
    [token]
  );

  // ---------- helper refs ----------
  const isMounted = useRef(true);
  const abortControllers = useRef([]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
      abortControllers.current.forEach((c) => c.abort());
    };
  }, []);

  const collator = useMemo(() => new Intl.Collator("id", { numeric: true, sensitivity: "base" }), []);
  
  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  // SORT sekolah: SD → SMP → SMA
  const sortSchools = (schools) => {
    const order = ["SD", "SMP", "SMA"];
    return [...schools].sort((a, b) => {
      const jenjangA = order.findIndex((j) => (a.school_name || "").toUpperCase().includes(j));
      const jenjangB = order.findIndex((j) => (b.school_name || "").toUpperCase().includes(j));
      return jenjangA - jenjangB;
    });
  };

  const removeBasementBekasi = (schools, branchId) => {
    if (branchId === "BKS") return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
    return schools;
  };

  // =========================
  // INIT: Branch + Semester + Dimensi
  // =========================
  const fetchInit = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();
    abortControllers.current.push(controller);

    try {
      const [branchRes, semesterRes, dimensiRes] = await Promise.all([
        APIMS.get(
          `/api/access/branches?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}&branch=${storageBranchGroping}&level=${storageLevel}`,
          { ...fetchParams, signal: controller.signal }
        ),
        // APILA.get(
        //   `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
        //   { ...fetchParams, signal: controller.signal }
        // ),
        APIMS.get(
          `/api/access/semesters?page=${page}&limit=${limit}&ascending=${descending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
        APILA.get(
          `/api/access/dimensis?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,
          { ...fetchParams, signal: controller.signal }
        ),
      ]);

      if (!isMounted.current) return;

      // Branch default pertama
      if (branchRes?.status === 200) {
        const branches = branchRes.data.data || [];
        setGetDataBranch(branches);
        if (branches.length > 0) {
          const firstBranch = branches[0].branch_code;
          setForm2((prev) => ({ ...prev, ysb_branch_id: firstBranch }));
        }
      }

      // Semester aktif
      if (semesterRes?.status === 200) {
        const semesters = semesterRes.data.data || [];
        const active = semesters.find((s) => s.status === 1) || semesters[0];
        setGetDataSemesterMap(semesters);
        if (active) {
          setNamaTA(active.name_year || "");
          setNamaSmstr(active.semester || "");
          setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
        }
      }

      // Dimensi aktif pertama
      if (dimensiRes?.status === 200) {
        const dims = (dimensiRes.data.data || []).filter((d) => d.status === 1);
        setGetDataDimensi(dims);
        if (dims.length > 0) setForm2((prev) => ({ ...prev, ysb_dimensi_id: dims[0].id }));
      }
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || err.message || "Error",
        icon: "error",
      });
    } 

  }, [ascending, descending, fetchParams, keyword, limit, page, storageBranchGroping, storageLevel]);

  useEffect(() => {
    fetchInit();
  }, [fetchInit]);

  // =========================
  // Fetch sekolah saat branch berubah
  // =========================
  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      initSchoolDone.current = false;
      initLevelDone.current = false;
      initKelasDone.current = false;
      setLoadingSchool(true); // ⬅️ school mulai load
      try {
        const res = await APIMS.get(
          `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );
        if (res?.status === 200) {
          let schools = res.data.data || [];

          // ✅ FILTER ULANG UNTUK ROLE DEVELOPER
          if (storageLevel === "developer" || storageLevel === "superadmin") {
            schools = schools.filter(
              (s) => s.ysb_branch_id === branchId
            );
          }

          schools = removeBasementBekasi(schools, branchId);
          schools = sortSchools(schools);

          setGetDataSchool(schools);

          // default sekolah pertama
          if (schools.length > 0) {
            // reset dependensi saat sekolah berubah (tingkatan/kelas/guru)
            setGetDataLevel([]);
            setGetDataKelas([]);
            setForm2((prev) => ({
              ...prev,
              ysb_school_id: schools[0].school_code,
              ysb_grade_level_id: "",
              ysb_kelas_id: "",
              ysb_teacher_id: "",
            }));
          } else {
            setGetDataLevel([]);
            setGetDataKelas([]);
            setForm2((prev) => ({ ...prev, ysb_school_id: "", ysb_grade_level_id: "", ysb_kelas_id: "", ysb_teacher_id: "" }));
            setGetDataTeacher([]);
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
          initSchoolDone.current = true;
          setLoadingSchool(false); // ⬅️ school SELESAI
          setLoading(false);       // ⬅️ shimmer BARU MATI DI SINI
      }
    },[ascending, fetchParams, limit, page, storageLevel]
  );

  useEffect(() => {
    if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
  }, [form2.ysb_branch_id, fetchSchoolsByBranch]);


  // =========================
  // Fetch tingkatan saat sekolah berubah
  // =========================
  const sortLevels = (levels) => {
    return [...levels].sort((a, b) =>
      (a?.name_level || "").localeCompare((b?.name_level || ""), "id", { numeric: true, sensitivity: "base" })
    );
  };

  const sortKelas = (kelas) => {
    return [...kelas].sort((a, b) =>
      (a?.name_kelas || "").localeCompare((b?.name_kelas || ""), "id", { numeric: true, sensitivity: "base" })
    );
  };

  const fetchLevelsBySchool = useCallback(
    async (schoolId, branchId) => {
      initLevelDone.current = false;
      initKelasDone.current = false; // reset kelas juga, karena kelas tergantung level

      if (!schoolId) return;

      setLoadingLevel(true);
      try {
        const res = await APIMS.get(
          `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (res?.status === 200) {
          let levels = res.data?.data || [];

          // filter by sekolah + cabang 
          levels = levels.filter((x) => x?.ysb_school_id === schoolId);
          if (branchId) levels = levels.filter((x) => x?.ysb_branch_id === branchId);

          levels = sortLevels(levels);
          setGetDataLevel(levels);

          if (levels.length === 0) {
            // kalau memang tidak ada tingkatan, kelas dianggap selesai juga
            initKelasDone.current = true;
          }

          // default tingkatan pertama
          if (levels.length > 0) {
            setForm2((prev) => ({
              ...prev,
              ysb_grade_level_id: levels[0].id,
            }));
          } else {
            setForm2((prev) => ({
              ...prev,
              ysb_grade_level_id: "",
              ysb_kelas_id: "",
            }));

          setGetDataKelas([]);
          }
        }
      } catch (err) {
        console.error(err);
        swal({
          title: "Failed",
          text: err?.response?.data?.message || err.message || "Gagal mengambil data tingkatan",
          icon: "error",
          timer: 3000,
          buttons: false,
        });

        setGetDataLevel([]);
        setGetDataKelas([]);
        setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));

      } finally {
        initLevelDone.current = true;
        setLoadingLevel(false);
      }
    }, [fetchParams]
  );

  // ketika sekolah berubah -> reset tingkatan & kelas -> fetch tingkatan
  useEffect(() => {
    if (!form2.ysb_school_id) {
      setGetDataLevel([]);
      setGetDataKelas([]);
      setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
    return;
    }

    // reset dulu biar tidak nyangkut data sekolah sebelumnya
    setGetDataLevel([]);
    setGetDataKelas([]);
    setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
    fetchLevelsBySchool(form2.ysb_school_id, form2.ysb_branch_id);
  }, [form2.ysb_school_id, form2.ysb_branch_id, fetchLevelsBySchool]);

  // =========================
  // Fetch kelas saat tingkatan berubah
  // =========================
  const fetchKelasByLevel = useCallback(
    async (gradeLevelId, schoolId, branchId) => {
      initKelasDone.current = false;

      if (!gradeLevelId) return;

      setLoadingKelas(true);
      try {
        const res = await APIMS.get(
          `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
          fetchParams
        );

        if (res?.status === 200) {
          let kelas = res.data?.data || [];

          // filter by tingkatan + (opsional) sekolah/cabang
          kelas = kelas.filter((x) => x?.ysb_grade_level_id === gradeLevelId);
          if (schoolId) kelas = kelas.filter((x) => x?.ysb_school_id === schoolId);
          if (branchId) kelas = kelas.filter((x) => x?.ysb_branch_id === branchId);

          kelas = sortKelas(kelas);
          setGetDataKelas(kelas);

          // default kelas pertama
          if (kelas.length > 0) {
            setForm2((prev) => ({
              ...prev,
              ysb_kelas_id: kelas[0].id,
            }));
          } else {
            setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
          }
        }
      } catch (err) {
        console.error(err);
        swal({
          title: "Failed",
          text: err?.response?.data?.message || err.message || "Gagal mengambil data kelas",
          icon: "error",
          timer: 3000,
          buttons: false,
        });
        setGetDataKelas([]);
        setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
      } finally {
        initKelasDone.current = true;
        setLoadingKelas(false);
      }
    }, [fetchParams]
  );

  useEffect(() => {
    if (!form2.ysb_grade_level_id) {
      setGetDataKelas([]);
      setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
      return;
    }

    // reset kelas dulu, lalu fetch ulang
    setGetDataKelas([]);
    setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
    fetchKelasByLevel(form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id);
  }, [form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id, fetchKelasByLevel]);

  
  // =========================
  // Filter complete (Guru gak wajib)
  // =========================
  const isFilterComplete =
    isFilterDirty &&
    !!form2.ysb_semester_id &&
    !!form2.ysb_branch_id &&
    !!form2.ysb_school_id &&
    !!form2.ysb_dimensi_id &&
    (!loadingLevel && (getDataLevel.length === 0 || !!form2.ysb_grade_level_id)) &&
    (!loadingKelas && (getDataKelas.length === 0 || !!form2.ysb_kelas_id));

  // =========================
  // Fetch table data
  // =========================
  const GetResponseData = useCallback(async () => {
    if (
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_school_id 
      // !form2.ysb_dimensi_id
    ) return;

    const params = {
      ysb_semester_id: form2.ysb_semester_id,
      level: storageLevel,
      branch: form2.ysb_branch_id,
      // ysb_dimensi_id: form2.ysb_dimensi_id,
      ysb_school_id: form2.ysb_school_id,
    };

    // ✅ tingkatan & kelas opsional (akan terisi default dari select)
    if (form2.ysb_grade_level_id) {
      params.ysb_grade_level_id = form2.ysb_grade_level_id;
    }
    if (form2.ysb_kelas_id) {
      params.ysb_kelas_id = form2.ysb_kelas_id;
    }

    try {
      const response = await APILA.get(
         "/api/rapot-main",
        {
        params,
        ...fetchParams,
        }
      );

    if (response?.status === 200) {
      setGetData(response.data.data || []);
      setGetDataKop(response.data.data_kop || []);
    }
    } catch (error) {
      swal({
        title: "Gagal",
        text: error?.response?.data?.message || "Gagal mengambil data",
        icon: "error",
      });
    }
  }, [form2, fetchParams, storageLevel]);

  // AUTO SELECT TAB
  useEffect(() => {
    if (getData.length > 0 && getData[0]?.data_element?.length > 0 && !selectedTab) {
      setSelectedTab(getData[0].data_element[0].name_element);
    }
  }, [getData, selectedTab]);

  // AUTO LOAD
  useEffect(() => {
    const schoolReady =
      initSchoolDone.current &&
      !loadingSchool &&
      !!form2.ysb_school_id;

    const gradeReady =
      initLevelDone.current &&
      !loadingLevel &&
      (getDataLevel.length === 0 || !!form2.ysb_grade_level_id);

    const kelasReady =
      initKelasDone.current &&
      !loadingKelas &&
      (getDataKelas.length === 0 || !!form2.ysb_kelas_id);

    if (
      firstLoadDone.current ||
      !form2.ysb_semester_id ||
      !form2.ysb_branch_id ||
      !form2.ysb_dimensi_id ||
      !schoolReady ||
      !gradeReady ||
      !kelasReady
    ) return;

    firstLoadDone.current = true;

    (async () => {
      setIsFetching(true);
      await GetResponseData(); // ✅ sekarang pasti sudah bawa default tingkatan+kelas
      setHasSearched(true);
      setIsFirstLoad(false);
      setIsFilterDirty(false);
      setIsFetching(false);
    })();
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_dimensi_id,
    form2.ysb_grade_level_id,
    form2.ysb_kelas_id,
    loadingSchool,
    loadingLevel,
    loadingKelas,
    getDataLevel.length,
    getDataKelas.length,
  ]);


  // Reset tab kalau filter berubah
  useEffect(() => {
    setSelectedTab(null);
  }, [
    form2.ysb_semester_id,
    form2.ysb_branch_id,
    form2.ysb_school_id,
    form2.ysb_dimensi_id,
    form2.ysb_grade_level_id,
    form2.ysb_kelas_id,
  ]);

  // =========================
  // HANDLER perubahan filter (select HTML)
  // =========================
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm2((prev) => ({ ...prev, [name]: value }));

    if (!isFirstLoad) {
      setIsFilterDirty(true);
      setHasSearched(false);
    }
  };

  // =========================
  // BUTTON CARI
  // =========================
  const handleCari = async () => {
    // validasi (biar user jelas)
    if (loadingSchool || loadingLevel || loadingKelas) {
      swal({
        title: "Mohon tunggu",
        text: "Data sekolah/tingkatan/kelas masih dimuat. Coba lagi sebentar.",
        icon: "info",
        timer: 2200,
        buttons: false,
      });
      return;
    }

    const gradeRequired = getDataLevel.length === 0 ? true : !!form2.ysb_grade_level_id;
    const kelasRequired = getDataKelas.length === 0 ? true : !!form2.ysb_kelas_id;

    if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id || !form2.ysb_dimensi_id || !gradeRequired || !kelasRequired) {
      swal({
        title: "Filter belum lengkap",
        text: "Pastikan Semester, Cabang, Sekolah, Tingkatan, Kelas, dan Dimensi sudah dipilih.",
        icon: "warning",
      });
      return;
    }

    setSelectedTab(null);
    setGetData([]);
    setHasSearched(false);
    setIsFetching(true);
    setSearchKeyword("");

    try {
      await GetResponseData();
      setHasSearched(true);
      setIsFilterDirty(false);
    } catch (err) {
      swal({
        title: "Failed",
        text: err?.response?.data?.message || "Terjadi kesalahan",
        icon: "error",
      });
    } finally {
      setIsFetching(false);
    }
  };


  // =========================
  // Nama Wali Kelas (diambil dari data kelas yang dipilih jika tersedia)
  // =========================
  const selectedKelasObj = useMemo(() => {
    if (!form2.ysb_kelas_id) return null;
    return (getDataKelas || []).find((k) => String(k?.id) === String(form2.ysb_kelas_id)) || null;
  }, [form2.ysb_kelas_id, getDataKelas]);
  
  const waliKelasName = useMemo(() => {
    // Sesuai request: tampilkan wali kelas dari field `ysb_name_teacher`
    const fromKelas =
      selectedKelasObj?.ysb_name_teacher ||
        "";
  
    const fromData =
      (Array.isArray(getData) &&
        getData.length > 0 &&
        (getData[0]?.ysb_name_teacher || getData[0]?.name_teacher || getData[0]?.teacher_name)) ||
      "";
  
    return safeStr(fromKelas || fromData);
  }, [getData, selectedKelasObj]);
  
  // =========================
  // Filter + Search + Sorting (frontend)
  // - Filter tingkatan/kelas diterapkan dari frontend (jika field tersedia di data rapor)
  // - Nama siswa diurutkan A -> Z
  // =========================
  // const displayedData = useMemo(() => {
  //   let rows = Array.isArray(getData) ? [...getData] : [];
   
  //   // Filter Tingkatan (jika field ada di row)
  //   if (form2.ysb_grade_level_id) {
  //     const selectedLevelId = String(form2.ysb_grade_level_id);
  //       rows = rows.filter((r) => {
  //         const rowLevelId = r?.ysb_grade_level_id;
  //         if (!rowLevelId) return true; // kalau field tidak ada, jangan dibuang
  //         return String(rowLevelId) === selectedLevelId;
  //       });
  //   }
   
  //   // Filter Kelas (jika field ada di row)
  //   if (form2.ysb_kelas_id) {
  //     const selectedKelasId = String(form2.ysb_kelas_id);
  //     rows = rows.filter((r) => {
  //       const rowKelasId =
  //         r?.ysb_kelas_id;
  //       if (!rowKelasId) return true;
  //       return String(rowKelasId) === selectedKelasId;
  //     });
  //   }
   
  //   // Search (Nama siswa / NISN)
  //   const q = safeStr(searchKeyword).trim().toLowerCase();
  //   if (q) {
  //     rows = rows.filter((r) => {
  //       const name = safeStr(r?.name_student).toLowerCase();
  //       const nisn = safeStr(r?.nisn).toLowerCase();
  //       return name.includes(q) || nisn.includes(q);
  //     });
  //   }
   
  //   // Sort nama siswa A -> Z
  //   rows.sort((a, b) => collator.compare(safeStr(a?.name_student), safeStr(b?.name_student)));

  //   return rows;
  // }, [collator, form2.ysb_grade_level_id, form2.ysb_kelas_id, getData, searchKeyword]);

  const displayedData = useMemo(() => {
    let rows = Array.isArray(getData) ? [...getData] : [];

    // Filter Tingkatan (jika field ada di row)
    if (form2.ysb_grade_level_id) {
      const selectedLevelId = String(form2.ysb_grade_level_id);
      rows = rows.filter((r) => {
        const rowLevelId = r?.ysb_grade_level_id;
        if (!rowLevelId) return true;
        return String(rowLevelId) === selectedLevelId;
      });
    }

    // Filter Kelas (jika field ada di row)
    if (form2.ysb_kelas_id) {
      const selectedKelasId = String(form2.ysb_kelas_id);
      rows = rows.filter((r) => {
        const rowKelasId = r?.ysb_kelas_id;
        if (!rowKelasId) return true;
        return String(rowKelasId) === selectedKelasId;
      });
    }

    // Search Nama siswa / NISN
    const q = safeStr(searchKeyword).trim().toLowerCase();
    if (q) {
      rows = rows.filter((r) => {
        const name = safeStr(r?.name_student).toLowerCase();
        const nisn = safeStr(r?.nisn).toLowerCase();
        return name.includes(q) || nisn.includes(q);
      });
    }

    // SORT:
    // siswa lama A-Z di atas, siswa baru order_absen di bawah
    rows.sort((a, b) => {
      const orderA =
        a?.order_absen === null ||
        a?.order_absen === undefined ||
        a?.order_absen === ""
          ? null
          : Number(a.order_absen);

      const orderB =
        b?.order_absen === null ||
        b?.order_absen === undefined ||
        b?.order_absen === ""
          ? null
          : Number(b.order_absen);

      const aIsNew = orderA !== null && !Number.isNaN(orderA);
      const bIsNew = orderB !== null && !Number.isNaN(orderB);

      if (!aIsNew && bIsNew) return -1;
      if (aIsNew && !bIsNew) return 1;

      if (aIsNew && bIsNew) {
        if (orderA !== orderB) return orderA - orderB;

        const nameCompare = collator.compare(
          safeStr(a?.name_student),
          safeStr(b?.name_student)
        );

        if (nameCompare !== 0) return nameCompare;

        return collator.compare(
          safeStr(a?.nisn),
          safeStr(b?.nisn)
        );
      }

      const nameCompare = collator.compare(
        safeStr(a?.name_student),
        safeStr(b?.name_student)
      );

      if (nameCompare !== 0) return nameCompare;

      return collator.compare(
        safeStr(a?.nisn),
        safeStr(b?.nisn)
      );
    });

    return rows;
  }, [
    collator,
    form2.ysb_grade_level_id,
    form2.ysb_kelas_id,
    getData,
    searchKeyword,
  ]);


  // const [showModal, setShowModal] = useState(false);
  // const [selectedRapor, setSelectedRapor] = useState(null);
  // const [dataKopRapor, setdataKopRapor] = useState(null);
      
  // const viewModalRapor = (id, rapor) => {
  //   try {
  //     setSelectedRapor(rapor || null);
  //     setShowModal(true);
  //     setdataKopRapor(getDataKop);
  //   } catch (err) {
  //     console.error('viewModalRapor error', err);
  //   }
  // }

    const [showModal, setShowModal] = useState(false);
    const [selectedRapor, setSelectedRapor] = useState(null);
    const [dataKopRapor, setdataKopRapor] = useState(null);
  
    const viewModalRapor = (id, rapor) => {
      try {
        // tutup dulu sebentar agar modal tidak membawa state murid sebelumnya
        setShowModal(false);
  
        setTimeout(() => {
          setSelectedRapor(rapor || null);
          setdataKopRapor(getDataKop || null);
          setShowModal(true);
        }, 0);
      } catch (err) {
        console.error("viewModalRapor error", err);
      }
    };
  
    const handleCloseModalRapor = () => {
      setShowModal(false);
      setSelectedRapor(null);
      setdataKopRapor(null);
    };

  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };

  return (
    <>
      <style>{shimmerStyle}</style>

      <div className="body rapor-page">
        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <span className="page-title-icon">
                <FontAwesomeIcon icon={faBookOpenReader} />
              </span>
              <h4 className="page-title-text">Rapor</h4>
            </div>
          </div>

          <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
            <ol className="custom-breadcrumb">
              <li className="custom-breadcrumb-item">
                <Link to="/dashboards-main">Beranda</Link>
              </li>
              <li className="custom-breadcrumb-separator">/</li>
              <li className="custom-breadcrumb-item active" aria-current="page">
                Rapor
              </li>
            </ol>
          </nav>
        </div>

        <div className="body-content rapor-content mt-2">
          <div className="rapor-filter-card">
            {/* <div className="rapor-filter-header">
              <div className="rapor-filter-title-wrap">
                <span className="rapor-filter-icon">
                  <FontAwesomeIcon icon={faFilter} />
                </span>
                <div>
                  <h5 className="rapor-filter-title">Filter Rapor</h5>
                  <p className="rapor-filter-subtitle">
                    Pilih semester, cabang, sekolah, tingkatan, dan kelas.
                  </p>
                </div>
              </div>
            </div> */}

            {loading ? (
              <div className="rapor-filter-grid rapor-filter-grid-super">
                {Array.from({ length: 6 }).map((_, index) => (
                  <div className="rapor-filter-field" key={index}>
                    {/* <div className="shimmer rapor-filter-shimmer-label" /> */}
                    <div className="shimmer rapor-filter-shimmer-control" />
                  </div>
                ))}
              </div>
            ) : (
              <div className="rapor-filter-grid rapor-filter-grid-super">
                <div className="rapor-filter-field">
                  <label className="rapor-filter-label">Tahun Ajaran / Semester</label>
                  <select
                    className="rapor-filter-select"
                    name="ysb_semester_id"
                    value={form2.ysb_semester_id}
                    onChange={handleChange}
                  >
                    <option value="" hidden>
                      {namaTA} (Semester {namaSmstr})
                    </option>
                    {getDataSemesterMap.map((item, index) => (
                      <option key={index} value={item?.id}>
                        {item?.name_year} (Semester {item?.semester})
                      </option>
                    ))}
                  </select>
                </div>

                <div className="rapor-filter-field">
                  <label className="rapor-filter-label">Cabang</label>
                  <select
                    className="rapor-filter-select"
                    name="ysb_branch_id"
                    value={form2.ysb_branch_id}
                    onChange={handleChange}
                  >
                    <option value="" hidden>
                      Pilih Cabang
                    </option>
                    {getDataBranch.map((item, index) => (
                      <option key={index} value={item?.branch_code}>
                        {item?.branch_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="rapor-filter-field">
                  <label className="rapor-filter-label">Sekolah</label>
                  <select
                    className="rapor-filter-select"
                    name="ysb_school_id"
                    value={form2.ysb_school_id}
                    onChange={handleChange}
                    disabled={loadingSchool}
                  >
                    <option value="" hidden>
                      {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                    </option>
                    {!loadingSchool &&
                      getDataSchool.map((item, index) => (
                        <option key={index} value={item?.school_code}>
                          {item?.school_name}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="rapor-filter-field">
                  <label className="rapor-filter-label">Tingkatan</label>
                  <select
                    className="rapor-filter-select"
                    name="ysb_grade_level_id"
                    value={form2.ysb_grade_level_id}
                    onChange={handleChange}
                    disabled={loadingLevel}
                  >
                    <option value="" hidden>
                      {loadingLevel ? "Memuat data tingkatan..." : "Pilih Tingkatan"}
                    </option>
                    {!loadingLevel &&
                      getDataLevel.map((item, index) => (
                        <option key={index} value={item?.id}>
                          {item?.name_level}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="rapor-filter-field">
                  <label className="rapor-filter-label">Kelas</label>
                  <select
                    className="rapor-filter-select"
                    name="ysb_kelas_id"
                    value={form2.ysb_kelas_id}
                    onChange={handleChange}
                    disabled={loadingKelas}
                  >
                    <option value="" hidden>
                      {loadingKelas ? "Memuat data kelas..." : "Pilih Kelas"}
                    </option>
                    {!loadingKelas &&
                      getDataKelas.map((item, index) => (
                        <option key={index} value={item?.id}>
                          {item?.name_kelas}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="rapor-filter-field rapor-filter-action">
                  <button
                    type="button"
                    onClick={handleCari}
                    disabled={!isFilterComplete}
                    className="rapor-filter-button"
                  >
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                    Cari Data
                  </button>
                </div>
              </div>
            )}
          </div>

          {isFetching && (
            <div className="rapor-loading">
              <PulseLoader color="#3f5bea" size={11} />
            </div>
          )}

          {hasSearched && !isFetching && (
            <>
              {!!waliKelasName && (
                <div className="rapor-class-info">
                  <span className="rapor-class-info-label">Wali Kelas</span>
                  <span className="rapor-class-info-value">
                    {toTitleCase(waliKelasName)}
                  </span>
                </div>
              )}

              <div className="rapor-search-wrap">
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  className="rapor-search-icon"
                />
                <input
                  className="rapor-search-input"
                  placeholder="Cari nama siswa atau NISN..."
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyword(e.target.value)}
                />
              </div>

              <div className="rapor-table-card">
                <div className="rapor-table-scroll">
                  <table className="rapor-table">
                    <thead>
                      <tr>
                        <th className="rapor-col-number">No</th>
                        <th className="rapor-col-name">Nama Siswa</th>
                        <th className="rapor-col-nisn">NISN</th>
                        <th className="rapor-col-action">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayedData.length === 0 ? (
                        <tr>
                          <td colSpan={4} className="rapor-empty-state">
                            Data tidak ditemukan
                          </td>
                        </tr>
                      ) : (
                        displayedData.map((rapor, index) => (
                          <tr key={rapor?.ysb_student_id || rapor?.id || index}>
                            <td className="rapor-col-number">
                              <span className="rapor-number-badge">{index + 1}</span>
                            </td>
                            <td className="rapor-col-name">
                              <span className="rapor-student-name">
                                {toTitleCase(rapor?.name_student)}
                              </span>
                            </td>
                            <td className="rapor-col-nisn">
                              <span className="rapor-nisn-text">
                                {rapor?.nisn || "-"}
                              </span>
                            </td>
                            <td className="rapor-col-action">
                              <button
                                type="button"
                                className="rapor-view-button"
                                onClick={() =>
                                  viewModalRapor(
                                    rapor?.ysb_student_id || rapor?.id,
                                    rapor
                                  )
                                }
                              >
                                <FontAwesomeIcon icon={faEye} />
                                <span>Lihat Rapor</span>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}

          {selectedRapor && (
            <ModalRapor
              key={selectedRapor?.ysb_student_id || selectedRapor?.id}
              show={showModal}
              onHide={handleCloseModalRapor}
              data_rapor={selectedRapor}
              data_kop={dataKopRapor}
              id_student={selectedRapor?.ysb_student_id || selectedRapor?.id}
              getData={getData}
            />
          )}
        </div>
      </div>
    </>
  );
}
